import React from 'react';
import { Monitor, Tablet, Smartphone, Globe } from 'lucide-react';
import { WEB_APPS, WEBAPPS_HEADER } from '../constants';
import { useLanguage } from '../LanguageContext';

const ICON_MAP = {
  Monitor:    <Monitor size={22} />,
  Tablet:     <Tablet size={22} />,
  Smartphone: <Smartphone size={22} />,
  Globe:      <Globe size={22} />,
};

export default function WebApps() {
  const { lang }  = useLanguage();
  const apps      = WEB_APPS[lang];
  const header    = WEBAPPS_HEADER[lang];

  return (
    <section
      className="pb-section pb-section-pad"
      id="webapps"
      style={{ background: 'var(--pb-bg-subtle)' }}
      data-testid="pb-webapps"
    >
      <div className="pb-container">
        <div style={{ textAlign: 'center', maxWidth: 580, margin: '0 auto 0' }}>
          <div className="pb-label" style={{ justifyContent: 'center' }}>{header.label}</div>
          <h2 className="pb-section-title">
            {header.title.split('\n').map((line, i) => (
              <React.Fragment key={i}>{line}{i === 0 && <br />}</React.Fragment>
            ))}
          </h2>
          <p className="pb-section-sub" style={{ margin: '16px auto 0', textAlign: 'center' }}>{header.sub}</p>
        </div>

        <div className="pb-webapps-grid">
          {apps.map(app => (
            <div key={app.title} className="pb-webapp-card" data-testid={`pb-webapp-${app.title.toLowerCase()}`}>
              <div className="pb-webapp-icon" aria-hidden="true">{ICON_MAP[app.icon]}</div>
              <div className="pb-webapp-title">{app.title}</div>
              <p className="pb-webapp-desc">{app.desc}</p>
            </div>
          ))}
        </div>

        <div style={{
          marginTop: 32, border: '1px solid var(--pb-border)', borderRadius: 14,
          padding: '28px 32px', background: 'white',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          flexWrap: 'wrap', gap: 20,
        }}>
          <div>
            <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--pb-deep-blue)', fontFamily: 'Outfit, sans-serif', marginBottom: 4 }}>
              {header.bannerTitle}
            </div>
            <div style={{ fontSize: 13, color: 'var(--pb-muted)' }}>{header.bannerSub}</div>
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {['Chrome', 'Safari', 'Edge', 'Firefox'].map(b => (
              <span key={b} style={{
                fontSize: 12, fontWeight: 600,
                background: 'var(--pb-bg-subtle)', color: 'var(--pb-muted)',
                padding: '5px 12px', borderRadius: 9999,
                border: '1px solid var(--pb-border)',
              }}>{b}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
